module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page",
    class: {
      previewMode: _vm.previewMode
    }
  }, [_c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('Topbar', {
    staticClass: "topbar",
    on: {
      "preview": _vm.preview
    }
  })], 1), _vm._v(" "), _c('main', {
    attrs: {
      "id": "main"
    }
  }, [_c('ResumeEditor', {
    staticClass: "editor"
  }), _vm._v(" "), _c('ResumePreview', {
    staticClass: "preview"
  })], 1), _vm._v(" "), _c('button', {
    attrs: {
      "id": "exitPreview"
    },
    on: {
      "click": _vm.exitPreview
    }
  }, [_vm._v("退出预览")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b8ea682"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 80
// module chunks = 1